import AddAlt16 from '@carbon/icons-react/es/add--alt/16';
import { Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';
import {
  AddButton,
  StyledCollapseIcon,
  StyledExpandIcon,
} from 'components/organisms/projects/project-sidebar/spaces-menu/styles';
import { PermissionRuleName } from 'constant';
import { useTranslation } from 'hooks/use-translation';
import { MenuTitleContainer } from '../../common';
import { MenuGroupTitlePropTypes } from './menu-group-title.types';
import { GroupTitle } from './menu-group.title.styles';

const ActionOptions = styled.div`
  padding-right: var(--spacing-04);
`;

export const MenuGroupTitle = ({
  title,
  tooltipTitle,
  moreActions,
  onSpaceAdd,
  isLoading,
  collapseAll,
  collapse,
  isNoProjectSpaces,
  isPrivate,
}: MenuGroupTitlePropTypes) => {
  const handleAdd = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onSpaceAdd();
  };

  const handleCollapse = () => {
    (document.activeElement as HTMLElement).blur();
    if (collapseAll !== undefined) {
      collapseAll();
    }
  };
  const placeHolder = useTranslation(
    collapse === true ? 'collapse_all' : 'expand_all',
  );

  return (
    <MenuTitleContainer>
      <GroupTitle ellipsis={{ tooltip: true }}>{title}</GroupTitle>
      <ActionOptions>
        {!isLoading && (
          <>
            {moreActions}
            {!isNoProjectSpaces && (
              <Tooltip title={placeHolder}>
                <AddButton
                  onClick={handleCollapse}
                  data-test-id="projects.spaces.collapse"
                  disabled={isLoading}
                  icon={
                    collapse === true ? (
                      <StyledCollapseIcon />
                    ) : (
                      <StyledExpandIcon />
                    )
                  }
                  className="add-button"
                  size="small"
                  type="text"
                />
              </Tooltip>
            )}

            <Tooltip title={tooltipTitle}>
              <AddButton
                onClick={handleAdd}
                data-test-id="projects.spaces.new"
                disabled={isLoading}
                icon={<AddAlt16 />}
                className="add-button"
                size="small"
                type="text"
                ruleName={
                  isPrivate
                    ? undefined
                    : PermissionRuleName.SpaceSharedCreateAction
                }
              />
            </Tooltip>
          </>
        )}
      </ActionOptions>
    </MenuTitleContainer>
  );
};
